import { Link } from 'react-router-dom';
import { useWishlistStore } from '../store/useWishlistStore';
import ProductCard from '../components/ProductCard';
import type { Product } from '../utils/apiHelpers';

export default function WishlistPage() {
  const items = useWishlistStore((s) => s.items);

  if (items.length === 0) {
    return (
      <main className="max-w-7xl mx-auto px-4 py-12">
        <h1 className="text-2xl font-bold text-[var(--foreground)] mb-4">
          Wishlist
        </h1>
        <p className="text-gray-500 mb-4">Your wishlist is empty.</p>
        <Link
          to="/shop"
          className="inline-block py-2 px-4 bg-green-600 text-white rounded-lg hover:bg-green-700"
        >
          Browse products
        </Link>
      </main>
    );
  }

  const products: Product[] = items.map((item) => ({
    id: Number(item.id),
    name: item.name,
    price: item.price,
    product_image: item.image,
  }));

  return (
    <main className="max-w-7xl mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold text-[var(--foreground)] mb-6">
        Wishlist ({items.length})
      </h1>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
        {products.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </main>
  );
}
